import React, { Component } from "react";
import config from 'react-global-configuration';
import axios from "axios";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class KYCStatesFilter extends Component {
    state = {
        kycStateList: [],
        selectedKYCStates: [],
        isKYCStateListLoading: true
    };

    componentDidMount() {
        this.getKYCStateList();
    }

    resetKYCStatesFilter() {
        this.setState({
            selectedKYCStates: [],
        });
    }

    getKYCStateList() {
        axios.get(config.get('API_URL') + '/filters/get-kyc-states/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                user_type: this.props.userType,
            }
        }).then(response => {
            if (Array.isArray(response.data) && response.data.length) {
                const kycStateList = response.data.map(item => ({
                    value: item.state_name,
                    label: item.state_name
                }));
                const selected = (this.props.value || []).map(val => ({
                    value: val,
                    label: val
                }));
                this.setState({
                    kycStateList,
                    isKYCStateListLoading: false,
                    selectedKYCStates: selected
                });
            }
        });
    }

    changeKYCState(optionSelected) {
        let selectedKYCStates = optionSelected.map(item => item.value);

        // Optional: reorder selected to top
        optionSelected.forEach((item) => {
            const index = this.state.kycStateList.findIndex(obj => obj.value === item.value);
            this.state.kycStateList.move(index, 0).join(',');
        });

        this.props.onSelectKYCStates(optionSelected, selectedKYCStates);

        this.setState({
            selectedKYCStates: optionSelected
        });
    }

    render() {
        return (
            <ReactMultiSelectCheckboxes
                name="kyc_states"
                isMulti
                value={this.state.selectedKYCStates}
                styles={reactSelectStyles}
                className="report-listbox"
                isClearable={false}
                onChange={this.changeKYCState.bind(this)}
                options={this.state.kycStateList}
                placeholderButtonLabel="Select [KYC States]"
                isLoading={this.state.isKYCStateListLoading}
            />
        );
    }
}

export default KYCStatesFilter;
